import React from 'react';
import WatchCard from './WatchCard';
import { Race } from '../../types/race';

type WatchGridProps = {
  races: Race[];
  isLoading: boolean;
  error: string | null;
};

const WatchGrid = ({ races, isLoading, error }: WatchGridProps) => {
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading races...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-lg text-red-500">Failed to load races</div>
      </div>
    );
  }

  if (!races.length) {
    return (
      <div className="race-grid-container">
        <div className="race-grid-empty">
          <p>No races found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {races.map(race => (
          <div key={race.id} className="">
            <WatchCard race={race} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default WatchGrid;
